export default __webpack_public_path__ + "media/alarm_cruiseship.7fc2a98.mp3";